import NavigationBar from "../widgets/Navigationbar";
import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import Home from "../Components/Home";
import AboutUs from "../Components/AboutUs";
import ProjectTable from "../Components/ProjectTable";
import Registration from "../Components/Registration";
import Login from "../Components/Auth";
import axios from "axios";
import { host } from "../constant/backendpath";
import Profilepage from "../Components/Profilepage";
import Forgetpassword from "../Components/Forgetpassword";
import { useLoader } from "../context/LoaderContext";
import Notification from "../widgets/Notification";
import Alert from "../widgets/AlertModal";
import AssignMentor from "../Components/Assignmentor";

function DashBoard() {
  const [current, setCurrent] = useState(0);
  const [isLogged, setIsLogged] = useState(false);
  const [chance, setChance] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    name: "",
    reg_no: "",
    dept: "",
    year: "",
    number: "",
    role: "",
  });
  const [total, setTotal] = useState(false);
  const [notification, setNotification] = useState(null);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const { setLoading } = useLoader();
  async function handleLogout() {
    try {
      const res = await axios.get(`${host}logout`, { withCredentials: true });
      if (res.status === 200) {
        // console.log("successfully logged out");
        setIsLogged(false);
        setCurrent(0);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async function dashboardFetch() {
    setLoading(true);
    try {
      const res = await axios.get(`${host}fetch`, { withCredentials: true });
      setLoading(false);
      if (res.status === 200) {
        const { result, total } = res.data;
        // console.log('Dashboard fetch - result:', result);
        // console.log('Dashboard fetch - total (profile complete):', total);
        setProfileDetails(result);
        setTotal(total);
        // If profile is incomplete (total === false), show popup
        setChance(!total);
        // persist-check for dismissed notifications
        const incomingNotification = result.notification ? result.notification : null;
        if (incomingNotification) {
          // stable hash function matching Notification.jsx
          const hashStr = (str) => {
            let h = 5381;
            for (let i = 0; i < str.length; i++) h = (h * 33) ^ str.charCodeAt(i);
            return (h >>> 0).toString(36);
          };
          const key = `notif_${hashStr(String(incomingNotification))}`;
          let dismissed = false;
          try {
            dismissed = !!localStorage.getItem(key);
          } catch (e) {
            dismissed = false;
          }
          setNotification(dismissed ? null : incomingNotification);
        } else {
          setNotification(null);
        }
        setIsLogged(true);
      }
    } catch (error) {
      // console.log(error);
      setIsLogged(false);
    }
  }
  useEffect(() => {
    dashboardFetch();
  }, [isLogged]);

  useEffect(() => {
    if (current === 5) {
      handleLogout();
    }
  }, [current]);

  async function updateProfile() {
    // console.log(profileDetails)
    try {
      //     const formData = new FormData();
      //     formData.append('name', profileDetails.name);
      //     formData.append('year', profileDetails.year);
      //     formData.append('dept', profileDetails.dept);
      //     formData.append('phone', profileDetails.number);
      //     formData.append('reg_no', profileDetails.reg_no);
      //     for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
      console.log(profileDetails.number);
      const res = await axios.post(
        `${host}profile`,
        {
          name: profileDetails.name,
          reg_no: profileDetails.reg_no,
          number: profileDetails.number,
          dept: profileDetails.dept,
          year: profileDetails.year,
        },
        { withCredentials: true },
      );
      if (res.status === 200) {
        // console.log(res.data);
        setAlertMessage("Successfully updated");
        setAlertType("success");
        setOpen(true);
      }
    } catch (err) {
      // console.error('Update profile error:', err);
      setAlertMessage("Something went wrong while updating. Please try again.");
      setAlertType("error");
      setOpen(true);
    }
  }

  // console.log(notification);
  // console.log(total);

  return (
    <>
      <NavigationBar setCurrent={setCurrent} logged={isLogged} profiles={profileDetails}/>
      <Alert
        open={open}
        setOpen={setOpen}
        message={alertMessage}
        type={alertType}
      />
      <Box
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          mt: "50px",
        }}
      >
        {current === 0 && (
          <Home
            isLogged={isLogged}
            setIsLogged={setIsLogged}
            setCurrent={setCurrent}
          />
        )}
        {current === 3 && <AboutUs />}
        {current === 1 && (
          <ProjectTable old={false} profileDetails={profileDetails} />
        )}
        {current === 2 && (
          <Registration
            isLogged={isLogged}
            setCurrent={setCurrent}
            chance={chance}
            setChance={setChance}
            updateProfile={updateProfile}
            profileDetails={profileDetails}
            setProfileDetails={setProfileDetails}
            total={total}
          />
        )}
        {current === 4 && (
          <Login setCurrent={setCurrent} setIsLogged={setIsLogged} />
        )}
        {current === 6 && (
          <Profilepage
            chance={chance}
            setChance={setChance}
            updateProfile={updateProfile}
            profileDetails={profileDetails}
            setProfileDetails={setProfileDetails}
          />
        )}
        {current === 7 && profileDetails.role === "admin" && (
        <AssignMentor profileDetails={profileDetails} />)}
        {current === 8 && <Forgetpassword setCurrent={setCurrent} />}
      </Box>
      {notification && (
        <Notification open={notification} setOpen={setNotification} />
      )}
    </>
  );
}

export default DashBoard;
